<template>
  <div class="Home">
    <van-skeleton title v-if="!showDetail" :row="14" />
    <div v-else>
      <div class="part1">
        <div class="p1_line_1">
          <div>日销售额(元)</div>
        </div>
        <div class="p1_line_2">
          <span>{{dataDay.goods_total_price}}</span>
          <span>
            {{dataDay.count||0}}
            <span>(单)</span>
          </span>
        </div>
      </div>


      <div class="part3">
        <div class="p_head">
          <span>开单趋势</span>
        </div>
        <div class="p_con">
          <div id="myChart" style="width:100%;height:250px"></div>
        </div>
      </div>
      <div class="openOrder" @click="toOpenOrder">
        <img src="./../../assets/img/layout/home/open_order_2.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
import { getHomeData ,getHomeStaffDay , getHomeStaffDate} from "@/api/layout/home";
import { timestampToDate } from "@/utils/timestamp";
import Cookies from "@/utils/Cookies";
export default {
  name: "Home",
  data() {
    return {
      chart: "", // 图表变量
      detailData: {},
      showDetail:true,
      role_type:'', // 1 开单 2 结账
      dataDay:{
        count:'',
        goods_total_price:'',
      },
      dataEchart:[]
    };
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getData();
    })
  },
  created() {
    
  },
  mounted() {
    setTimeout(()=>{
      getHomeStaffDay().then(res=>{
        this.dataDay.count = res.data.count || 0
        this.dataDay.goods_total_price = res.data.goods_total_price || "0.00"
        this.showDetail = true
      })
    },100)
  },
  methods: {
    // 获取数据
    getData() {
      getHomeStaffDate().then(res => {
        if (res.code == 200) {
          this.dataEchart = res.data;
          this.$nextTick(() => {
            this.$nextTick(() => {
              var xse = []
              var xsl = []
              var data_echart = {
                date:[],
                echarts:[]
              } 
              for (let i = 0; i < this.dataEchart.length; i++) {
                const item = this.dataEchart[i];
                data_echart.date.push((item.date).substring(5))
                xse.push(item.goods_total_price || 0)
                xsl.push(item.count || 0)
              }
              data_echart.echarts=[xse,xsl]
              this.drawEchart("myChart", data_echart);
            });
          });
        }
      });
    },
    // 初始化echart
    drawEchart(id, data) {
      this.chart = this.$echarts.init(document.getElementById(id));
      this.chart.setOption({
        backgroundColor: "", //背景颜色透明
        color: "#31b158",
        tooltip: {
          trigger: "axis", //鼠标经过提示
          axisPointer:{
            z:3
          },
          formatter: (params)=>{
            var name = ["开单数"]
            return `
              <div>
                <div>${params[0].name}</div>
                <div>
                  <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#31b158;"></span>${params[0].seriesName}:${data.echarts[params[0].seriesIndex][params[0].dataIndex]}
                </div>
                <div>
                  <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#31b158;"></span>${name[params[0].seriesIndex]}:${data.echarts[params[0].seriesIndex+1][params[0].dataIndex]}
                </div>
              </div>`
          }
        },
        legend: {
          selectedMode: "single",
          icon: "circle", //icon为圆角矩形
          x: "center",
          y: "10",
          data: ["开单额"],
          textStyle: {
            //图例文字的样式
            color: "#31b158",
            fontSize: 12
          }
        },
        grid: {
          right: "5%",
          top: "20%",
          left: "5%",
          bottom: "15%",
          // containLabel: true
        },
        xAxis: {
          type: "category",
          data: data.date,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#dedede"
            }
          },
          axisTick: {
            show: false,
            lineStyle: {
              color: "#dedede"
            }
          }
        },
        yAxis: {
          type: "value",
          splitLine: { show: false }, //去除网格线
          show: false //隐藏y轴
        },
        series: [
          {
            name: "开单额",
            data: data.echarts[0],
            type: "line",
            smooth: true,
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#31b158" },
                  { offset: 1, color: "#fff" }
                ])
              }
            }, //填充区域样式
            lineStyle: {
              color: "#31b158",
              width: 1
            }, //线条的样式
            itemStyle: {
              opacity: 0 //为0不会绘制图形拐点消失
            } //拐点的样式
          },
        ]
      });
      this.showDetail = true
    },
    // 去开单页面
    toOpenOrder() {
      if(this.role_type == 2){
        this.$router.push({
          path: "/openOrder/orderCheckOut"
        });
      }else{
        this.$router.push({
          path: "/openOrder/order"
        });
      }
    },
  }
};
</script>

<style lang="less" scoped>
.Home {
  position: relative;
  .part1 {
    width: 100%;
    height: 3rem;
    box-sizing: border-box;
    background: url(./../../assets/img/layout/home/bg.png) no-repeat center
      bottom;
    background-size: 100%;
    color: #fff;
    padding: 0.5rem 0.3rem 0;
    font-size: 0.28rem;
    margin-bottom: 0.2rem;
    position: relative;
    .p1_line_1 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.34rem;
      & > div:nth-child(2) {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
    .p1_line_2 {
      font-size: 0.48rem;
      letter-spacing: 0.01rem;
      font-weight: bold;
      margin-bottom: 0.4rem;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      & > span {
        font-size: 0.6rem;
        &:nth-child(1) {
          width: 4rem;
        }
        &:nth-child(2) {
          span {
            font-size: 0.3rem;
            vertical-align: middle;
          }
        }
      }
    }
    .p1_line_3 {
      font-size: 0.28rem;
      & > span:nth-child(2) {
        color: #fde07d;
        margin-left: 0.12rem;
      }
    }
    .p1_line_4 {
      width: 6.4rem;
      margin-left: -3.2rem;
      height: 0.8rem;
      background: url(./../../assets/img/layout/home/bg_1.png) no-repeat center
        bottom;
      background-size: 100%;
      border-radius: 0.1rem 0.1rem 0px 0px;
      position: absolute;
      left: 50%;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      & > div {
        width: 50%;
        height: 0.28rem;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 0.24rem;
          height: 0.26rem;
        }
        span {
          font-size: 0.28rem;
          color: #d1c1a7;
          line-height: 0.28rem;
          margin-left: 0.1rem;
        }
        &:nth-child(1) {
          border-right: 0.005rem solid #d1c1a7;
        }
      }
    }
    .p1_line_5 {
      width: 6.4rem;
      margin-left: -3.2rem;
      height: 0.8rem;
      background: #ffffff;
      border-radius: 0px 0px 0.1rem 0.1rem;
      position: absolute;
      left: 50%;
      box-shadow: 0px 0.05rem 0.16rem 0px rgba(204, 204, 204, 0.3);
      bottom: -0.8rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 0.3rem;
      color: #333;
      font-weight: bold;
      box-sizing: border-box;
      font-size: 0.28rem;
      & > div:nth-child(2) {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        span {
          margin-right: 0.1rem;
        }
      }
    }
  }

  .part2 {
    width: 100%;
    background-color: #fff;
    padding: 0 0.3rem;
    box-sizing: border-box;
    color: #333;
    margin-bottom: 0.2rem;
    padding-bottom: 0.1rem;
    .p_title {
      font-weight: bold;
      line-height: 1rem;
      border-bottom: 0.01rem solid #e6e6e6;
    }
    .p_con {
      margin-top: 0.2rem;
      width: 100%;
      box-sizing: border-box;
      // padding-left: 0.48rem;
      // padding: 0 0.26rem;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      div {
        width: 50%;
        box-sizing: border-box;
        border-bottom: 0.01rem solid #e6e6e6;
        border-right: 0.01rem solid #e6e6e6;
        padding:0 0.26rem;
        height: 0.92rem;
        font-size: 0.28rem;
        line-height: 0.28rem;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: space-between;
        & > span:nth-child(1) {
          width: 50%;
        }
        & > span:nth-child(2) {
          width: 0%;
        }
        & > span:nth-child(3) {
          width: 50%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          color: #31b158;
        }
        &:nth-child(3),&:nth-child(4) {
          border-bottom: none;
        }
        &:nth-child(2n) {
          border-right: none;
        }
      }
    }
  }

  .part3 {
    width: 100%;
    background-color: #fff;
    box-sizing: border-box;
    color: #333;
    margin-bottom: 0.2rem;
    padding-bottom: 0.1rem;
    .p_head {
      display: flex;
      padding: 0 0.3rem;
      align-items: center;
      justify-content: space-between;
      border-bottom: 0.01rem solid #e6e6e6;
      & > span:nth-child(1) {
        font-weight: bold;
        line-height: 1rem;
      }
    }
  }

  .openOrder {
    width: 4.91rem;
    height: 1.16rem;
    position: fixed;
    left: 50%;
    margin-left: -2.45rem;
    bottom: 66px;
    z-index: 2;
    img {
      width: 100%;
      height: 100%;
    }
    &.CheckOut{
      bottom: 2rem;
    }
  }
}
</style>